import { connect } from 'react-redux';

import { VillageCardPage } from './VillageCardPage';
import { IState } from '../../store';

export interface IVillageCardPageStoreProps {
  isMenuVisible: boolean;
  isFat: boolean;
  isCroppedCard?: boolean;
  isPromotionsVillageData: boolean;
}

export function mapStateToProps(state: IState): IVillageCardPageStoreProps {
  return {
    isMenuVisible: state.navigationLinks.isMenuVisible,
    isFat: state.isFatCard,
    isCroppedCard: state.isCroppedCard,
    isPromotionsVillageData: !!(state.promotionsVillageData?.promotions?.length > 0),
  };
}

export const VillageCardPageContainer = connect<IVillageCardPageStoreProps>(mapStateToProps)(VillageCardPage);
